import * as Reflux from "reflux";
export const QuickEntryActions = {
	blur: Reflux.createAction(["blur"]),
	search: Reflux.createAction({
		actionName: "search",
		sync: true,
	}),
	showMoreResults: Reflux.createAction(["moreResults"]),
	selectResult: Reflux.createAction(["selectResult"]),
	clear: Reflux.createAction(["clear"]),
};
